import React, {Component} from 'react'
import Helmet from 'react-helmet'
import StyleMarkdown from '../StyleMarkdown'
import Carousel from '../Carousel'
import Posts from '../Posts'
import Section from '../Section'
import Vimeo from '../Vimeo'
import PageButton from '../PageButton'
import Link from '../Link'
import styles from './PageLayout.css'

export default class PageLayout extends Component {
  render () {
    return (
      <div className={styles.cont}>
        <Helmet title={this.props.title}/>
        {
          this.props.video ? (
            <div className={styles.videoCont}>
              <div className={styles.videoInner}>
                <Vimeo video={this.props.video} image={this.props.image}/>
              </div>
            </div>
          ) : this.props.image && (
            <div className={styles.imageCont}>
              <img className={styles.image} src={this.props.image}/>
            </div>
          )
        }
        {
          this.props.sections.map((section, i) => (
            <Section title={section.title} key={i}>
              {
                section.body ? (
                  <div className={styles.body}>
                    <StyleMarkdown html={section.body}/>
                  </div>
                ) : section.carousel ? (
                  <Carousel carousel={section.carousel}/>
                ) : section.button ? (
                  <div className={styles.widthWrapper}>
                    <Link to={section.button.link}>
                      <PageButton>{section.button.text}</PageButton>
                    </Link>
                  </div>
                ) : section.posts && (
                  <Posts posts={section.posts}/>
                )
              }
            </Section>
          ))
        }
      </div>
    )
  }
}






// WEBPACK FOOTER //
// ./src/Rist/modules/PageLayout/index.js